import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { UserContext } from "./context/UserContext";
import FooterBn from "./FooterBn";
import "./styles/Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [view, setView] = useState("login");
  const { loginUser } = useContext(UserContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://server.goatteachers.com/api/auth/login",
        {
          email,
          password,
        },
      );

      const token = response.data.token;
      localStorage.setItem("token", token);
      loginUser(response.data.user);

      // alert("Login successful!");
      navigate("/");
    } catch (error) {
      console.error("Error during login:", error);
      setError(error.response?.data?.message || "Error during login");
    }
  };

  const handleForgotPasswordClick = () => {
    setView("forgotPassword");
  };

  const handleResetPasswordClick = () => {
    setView("resetPassword");
  };

  const handleBackToLogin = () => {
    setView("login");
  };

  return (
    <>
      <section className="login-section">
        <div className="login-container">
          <div className="login-box">
            {view === "login" && (
              <>
                <h2 className="iqWTbl">Sign in</h2>

                {error && <p className="error-message">{error}</p>}

                <form onSubmit={handleSubmit} className="login-form">
                  <div className="input-group">
                    <label>Email</label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="input-field"
                    />
                  </div>

                  <div className="input-group">
                    <label>Password</label>
                  </div>
                  <div className="password-container">
                    <input
                      type={showPassword ? "text" : "password"}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      className="input-field"
                    />
                    <i
                      className={`fa ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: "pointer" }}
                    />
                  </div>

                  <button type="submit" className="login-btn">
                    Log in
                  </button>
                </form>

                <p className="signup-link">
                  <a href="/forgot-password">Forgot password?</a>
                </p>
                <p className="signup-link">
                  I don't have an account <a href="/signup">Sign up</a>
                </p>
              </>
            )}
          </div>
        </div>
        <FooterBn />
      </section>
    </>
  );
}

export default Login;
